/**
 * @module worktango settings
 */
import { config } from '@worktango/ai-assistant/react';
import { getStringFlagValue } from '@worktango/feature-flags-react';

const termsUrl = 'https://worktango.com/terms-of-use/';
const privacyUrl = 'https://worktango.com/privacy-policy/';
const noticeUrl = 'https://worktango.com/privacy-notice/';
const contactUsUrl = 'https://worktango.com/contact-us/';
const iconBaseUrl = 'https://s3-us-west-2.amazonaws.com/disengage-icons';
const contentUrl = 'https://s3.ca-central-1.amazonaws.com/disengagecontent';
const excelTemplateUrl = `/excel_templates`;
const supportUrl = `/support`;

const kazooUrl = import.meta.env.VITE_KAZOO_URL;
const kazooPeopleEndpoint = '/admin/directory/people';
const kazooImportHistoryEndpoint = '/admin/integrations/import-history';
const kazooLogoutEndpoint = '/auth/logout';
const kazooPulseAuthEndpoint = '/redirect/pulse-auth';

// Depends on `VITE_API_URL` being defined in the environment during build.
// This is defined in the Gitlab env vars during CI, or in a `.env` file during development.
const host = import.meta.env.VITE_API_URL;

const surveyUrl = import.meta.env.VITE_SURVEY_URL;

const authExpireWindow = 60 * 10; // 10min in seconds

// A list of graphql query names that do not require authentication.
const publicGraphqlQueries = [
  'login',
  'getActivationUser',
  'activateUser',
  'forgotPassword',
  'setNewPasswordWithToken',
];

config.setLlmCallUrlStrategy(() => host + '/ai-assistant?targetPath=/api/api-ai-assistant/v1/chat');
config.setStructuredResponseUrlStrategy(
  () => host + '/ai-assistant?targetPath=/api/api-ai-assistant/v1/structured-response',
);
config.setSynthesizeUrlStrategy(() => host + '/ai-assistant?targetPath=/api/api-ai-assistant/v1/tts');
config.setTranscribeUrlStrategy(() => host + '/ai-assistant?targetPath=/api/api-ai-assistant/v1/stt');
config.setKazooUrlStrategy((urlPath) => host + '/ai-assistant?targetPath=' + urlPath);
// Lazy: evaluated on every chat / structured-response call, so flipping the
// `worktango-coach-llm-region` DevCycle flag takes effect on the next request
// without a deploy or page reload.
config.setLlmRegionStrategy(() => getStringFlagValue('worktango-coach-llm-region', '') || undefined);
// From Pulse, we can talk to Pulse :P
config.setPulseUrlStrategy((urlPath) => {
  if (urlPath.startsWith('http')) {
    // Legacy url pattern, just return it
    return urlPath;
  } else if (urlPath.startsWith('/')) {
    // New url pattern, add the host
    return host + urlPath;
  } else {
    return host + '/' + urlPath;
  }
});

export {
  authExpireWindow,
  contactUsUrl,
  contentUrl,
  excelTemplateUrl,
  host,
  iconBaseUrl,
  kazooImportHistoryEndpoint,
  kazooLogoutEndpoint,
  kazooPeopleEndpoint,
  kazooPulseAuthEndpoint,
  kazooUrl,
  noticeUrl,
  privacyUrl,
  publicGraphqlQueries,
  supportUrl,
  surveyUrl,
  termsUrl,
};
